export const MOBILE_APP_STORES = Object.freeze({
  android: 'https://play.google.com/store/apps/details?id=com.wormos.spacedesk&hl=en',
  ios: 'https://apps.apple.com/in/app/spacedesk-workspace/id6773883139',
});

